import moment from 'moment'

// 主动回访池 - 列配置
export const columns = [
  {
    title: '患者ID',
    dataIndex: 'ucPatientId',
    width: 100
  },
  {
    title: '患者姓名',
    dataIndex: 'patientName',
    width: 120,
    slots: { customRender: 'patientName' }
  },
  {
    title: '昵称',
    dataIndex: 'nickName',
    width: 120
  },
  {
    title: '患者手机号码',
    dataIndex: 'patientPhone',
    width: 150,
    slots: { customRender: 'patientPhone' }
  },
  {
    title: '医生姓名',
    dataIndex: 'doctorNames',
    width: 140,
    customRender: ({ text }) => {
      return Array.isArray(text) ? text.join('、') : text || '--'
    }
  },
  {
    title: '分配时间',
    dataIndex: 'assignedAt',
    width: 180
  },
  {
    title: '回访开始时间',
    dataIndex: 'followupStartedAt',
    width: 180,
    sorter: true,
    sortDirections: ['ascend', 'descend']
  },
  {
    title: '回访结束时间',
    dataIndex: 'followupCompletedAt',
    width: 180,
    sorter: true,
    sortDirections: ['ascend', 'descend']
  },
  {
    title: '完成回访备注',
    dataIndex: 'completeReason',
    width: 180,
    ellipsis: true
  },
  {
    title: '下次回访时间',
    dataIndex: 'nextFollowupAt',
    width: 180
  },
  {
    title: '负责回访健管',
    dataIndex: 'daName',
    width: 200,
    slots: { customRender: 'daName' }
  },
  {
    title: '回访状态',
    dataIndex: 'followupStatusName',
    width: 110,
    slots: { customRender: 'followupStatusName' }
  },
  {
    title: '上次触达时间',
    dataIndex: 'lastTouchAt',
    width: 300,
    sorter: true,
    sortDirections: ['ascend', 'descend'],
    slots: { customRender: 'lastTouchAt' }
  },
  {
    title: '通话状态',
    dataIndex: 'callStatus',
    width: 100,
    customRender: ({ text }) => {
      const statusMap = {
        1: '接通',
        2: '未接通'
      }
      return statusMap[text]
    }
  },
  {
    title: '达成转化',
    dataIndex: 'conversionFlagName',
    width: 100,
    customRender: ({ text }) => {
      return text || '--'
    }
  },
  {
    title: '转化场景',
    dataIndex: 'conversionSceneName',
    width: 140,
    customRender: ({ text }) => {
      return text || '--'
    }
  },
  {
    title: '绑定医生数',
    dataIndex: 'boundDoctorNum',
    sorter: true,
    sortDirections: ['ascend', 'descend'],
    width: 130,
    slots: { customRender: 'boundDoctorNum' }
  },
  {
    fixed: 'right',
    title: '操作',
    dataIndex: 'operation',
    width: 250,
    slots: { customRender: 'operation' }
  }
]

export const paginationConfig = {
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: total => `共 ${total} 条`
}

export const defaultQuery = {
  patientName: null,
  patientPhone: null,
  ucPatientId: null,
  // followupStatus: null,
  followupStatusList: [],
  queryType: null,
  taskSourceType: null,
  assignedDaUcUserId: [],
  departmentIds: [],
  callStatus: null,
  conversionScene: null,
  benefitConversionFlag: null,
  revisitDateFlag: null,
  assignedStartAt: null,
  assignedEndAt: null,
  followupStartAt: null,
  followupEndAt: null,
  lastTouchStartAt: null,
  lastTouchEndAt: null,
  sortField: null,
  sortOrder: null
}
// 主动回访池 - 操作按钮配置
export const operationButtons = [
  {
    key: 'handleCall',
    label: '拨打电话',
    visible: record => record.showCall
  },
  {
    key: 'handleFullText',
    label: '通话全文',
    visible: record => record.showCallFullText
  },
  {
    key: 'handlePath',
    label: '回访路径',
    visible: record => record.showFollowupPath
  },
  // 小结相关按钮
  {
    key: 'handleSummary',
    label: '查看小结',
    visible: record => record.showViewSummary
  },
  {
    key: 'handleSummary',
    label: '人工小结',
    visible: record => record.showManualSummary
  },
  {
    key: 'onCreateSummary',
    label: 'AI重新生成小结',
    visible: record => record.showRegenerateAiSummary
  },
  {
    key: 'handleSummary',
    label: '填写小结',
    visible: record => record.showGenerateSummary
  },
  {
    key: 'handleRemove',
    label: '移除任务',
    visible: record => record.showRemove
  },
  {
    key: 'handleComplete',
    label: '完成回访',
    visible: record => record.showComplete
  },
  {
    key: 'handleFillNextFollowupTime',
    label: '补充下次回访时间',
    visible: record => record.showFillNextFollowupTime
  }
]

// 日期选择器快捷筛选项配置
const dateRanges = {
  today: [moment().startOf('day'), moment().endOf('day')],
  yesterday: [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
  thisWeek: [moment().startOf('week'), moment().endOf('week')],
  lastWeek: [
    moment().subtract(1, 'week').startOf('week'),
    moment().subtract(1, 'week').endOf('week')
  ],
  thisMonth: [moment().startOf('month'), moment().endOf('month')],
  lastMonth: [
    moment().subtract(1, 'month').startOf('month'),
    moment().subtract(1, 'month').endOf('month')
  ]
}

// 日期选择器快捷筛选项显示配置
export const dateRangeOptions = {
  今天: dateRanges.today,
  昨天: dateRanges.yesterday,
  本周: dateRanges.thisWeek,
  上周: dateRanges.lastWeek,
  本月: dateRanges.thisMonth,
  上月: dateRanges.lastMonth
}

// 回访类型选项配置
export const queryTypeOptions = [
  { value: 0, label: '全部回访' },
  { value: 1, label: '我回访的' },
  { value: 4, label: '我加入的' },
  { value: 2, label: '我分配的' },
  { value: 5, label: '分配给我的' },
  { value: 3, label: '其他回访' }
]
// 任务类型选项配置
export const taskTypeOptions = [
  { value: 0, label: '全部任务' },
  { value: 1, label: '我加入的' },
  { value: 2, label: '被分配的' }
]

// 回访状态选项配置
export const followupStatusOptions = [
  { value: 1, label: '待回访' },
  { value: 2, label: '进行中' },
  { value: 8, label: '进行中-触达成功' },
  { value: 9, label: '进行中-触达未成功' },
  { value: 10, label: '已回访-触达成功' },
  { value: 11, label: '已回访-触达未成功' },
  { value: 3, label: '已回访' },
  // { value: 4, label: '进行中-未触达' },
  { value: 6, label: '已移除-系统' },
  { value: 7, label: '已移除-人为' }
]

// 转化场景选项配置
export const conversionSceneOptions = [
  { value: 1, label: '患者购药' },
  { value: 2, label: '健管补充诊疗记录' },
  { value: 3, label: '健管修改复诊日期' }
]

// 是否达成效益转化选项配置
export const benefitConversionFlagOptions = [
  { value: null, label: '全部效益情况' },
  { value: 1, label: '已达成效益转化' },
  { value: 0, label: '未达成效益转化' }
]

// 是否设置复诊日期选项配置
export const revisitDateFlagOptions = [
  { value: null, label: '全部复诊设置情况' },
  { value: 1, label: '已设置复诊日期' },
  { value: 0, label: '未设置复诊日期' }
]

// 部门/健管 筛选类型（纯前端交互切换）
export const filterTypeOptions = [
  { value: 'department', label: '部门' },
  { value: 'da', label: '健管' }
]

export const genderMap = {
  0: '女',
  1: '男',
  2: '未知'
}
/**
 * 禁用某些日期的函数，用于日期选择器等场景
 * @param {Date} current - 当前需要检查的日期
 * @param {number} years - 允许选择的最大年数范围，默认为1
 * @returns {boolean} - 如果日期应该被禁用则返回true，否则返回false
 */
export const disabledDate = (current, years = 1) => {
  if (!current) {
    return false
  }

  const today = new Date()
  const yearsBefore = new Date()
  yearsBefore.setFullYear(today.getFullYear() - years)

  // 检查当前日期是否大于今天或小于指定年数前的日期
  // 如果是，则返回true（禁用该日期）
  return current > today || current < yearsBefore
}
// 回访状态色块说明
export const followupLegend = [
  {
    label: '我加入的',
    value: 4,
    style: {
      width: '14px',
      height: '14px',
      borderRadius: '4px',
      background: '#FA92C9'
    }
  },
  {
    label: '我分配的',
    value: 2,
    style: {
      width: '14px',
      height: '14px',
      borderRadius: '4px',
      background: '#78E3D6'
    }
  },
  {
    label: '分配给我的',
    value: 5,
    style: {
      width: '14px',
      height: '14px',
      borderRadius: '4px',
      background: '#FDD265'
    }
  }
]
